<template>
    <div>
        <b-card-text>
            <div v-html="text"></div>
        </b-card-text>
        <vue-dropzone 
            v-model="fotos" 
            ref="myVueDropzone" 
            id="dropzone"
            v-on:vdropzone-success="vdropzone_success_handler"
            :options="options"
        >
        </vue-dropzone>
    </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
    props: ['fotos', 'options', 'text'],
    methods: {
        vdropzone_success_handler(file, response) {
            this.$emit('documentosSubidos', response);
        }
    },
    components: {
        vueDropzone: vue2Dropzone,
    }
}
</script>